define(['edge/platform/base/BaseCtrl'], (BaseCtrl) => {

    const fn = function ($scope, $filter, submissionViewModel, ContextService, MagnoliaService, LoggingService, BaslerLoggingConstants, RecurrentUserService) {
        const ctrl = Object.create(BaseCtrl);

        ctrl.init = function () {

            LoggingService.logInfo(BaslerLoggingConstants.BIND);
            RecurrentUserService.clearDataInLocalStorage();

            const submissionVm = submissionViewModel();
            const submission = submissionVm.value;
            $scope.submission = submission;

            createLocalKeysForNextStepsElement(submission);

            $scope.translateData = {
                directJobNumber: submission.quoteID,
            };

            const channel = ContextService.getChannel().toUpperCase();

            if (ContextService.isPartnerProduct()) {
                if (ContextService.isPartnerLeasingProduct()) {
                    $scope.translateData.leasingContractNr = submission.draftData.lobs.mFPLine.vehicles[0].additionalInterest.leaseContractNumber;

                    const {monthlyPremium} = submission.quoteData.offeredQuotes.find(quote => quote.isSelected);
                    $scope.translateData.monthlyPremium = $filter('gwCurrency')(monthlyPremium);
                }

                MagnoliaService.getFragment(ContextService.getProductCode(), `confirmation-contact-${channel}`)
                    .then((fragmentConfirmation) => {
                        $scope.fragmentConfirmationContact = fragmentConfirmation;
                    });

                MagnoliaService.getFragment(ContextService.getProductCode(), 'cancellationletter-preinsurer')
                    .then((fragmentCancelletion) => {
                        $scope.fragmentCancellationLetter = fragmentCancelletion;
                    });
            } else {
                try {
                    $scope.crossSellingFragment = undefined;
                    MagnoliaService.getFragment(ContextService.getProductCode(), `confirmation-cross-selling-${channel}`)
                        .then((fragmentThankyou) => {
                            const fragment = JSON.parse(fragmentThankyou);
                            if (MagnoliaService.isValidFragment(fragment)) {
                                $scope.crossSellingCards = fragment.cards;
                                $scope.crossSellingFragmentTitle = fragment.overallTitleText;
                                $scope.crossSellingFragment = fragment;
                            }
                        })
                        .catch(() => {
                            //expected to happen for example when a fragment for a product does not exist thats why there is no logging to the backend here
                        });
                } catch (e) {
                    LoggingService.logInfo(BaslerLoggingConstants.CONTACTUS, new Error(e));
                    console.error(e);
                }
            }
        };

        function createLocalKeysForNextStepsElement(submission) {
            const countTextElements = 3;
            const isTCS = ContextService.isTCSProduct();
            const prefixForTextElements = "quoteandbind.common.views.mfp-confirmation.next-step";
            const postfixForTextElements = "-matriculation-number.step";

            // check if the matriculation number is missing for one of the vehicles
            const someMatriculationNumberIsNotSet = submission.draftData.lobs.mFPLine
                .vehicles.some(vehicle => !vehicle.matriculationInformation || !vehicle.matriculationInformation.matriculationNumber)

            $scope.steps = [];
            for (let i = 1; i <= countTextElements; i++) {
                $scope.steps.push(`${prefixForTextElements}${isTCS ? ".tcs" : ""}.${someMatriculationNumberIsNotSet ? "without" : "with"}${postfixForTextElements}${i}`);
            }
        }

        $scope.isPartnerLeasing = ContextService.isPartnerLeasingProduct;

        $scope.isPartnerProduct = ContextService.isPartnerProduct;

        $scope.isDirectProduct = ContextService.isDirectProduct;

        $scope.isDirectOrTCSProduct = ContextService.isDirectProduct() || ContextService.isTCSProduct();

        return ctrl.create($scope);
    };

    fn.$inject = ['$scope', '$filter', 'submissionViewModel', 'ContextService', 'MagnoliaService', 'LoggingService', 'BaslerLoggingConstants', 'RecurrentUserService'];

    return fn;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/controllers/MFPConfirmationCtrl.js